<template>
  <div class="app-container">
    <el-form
			:model="searchData"
			:inline="true"
			label-width="140px"
			label-position="right"
			ref="searchData"
		>
			<el-form-item label="推荐码" prop="phone">
        <el-input v-model="searchData.phone" :maxlength="11" placeholder="请输入" allowClear></el-input>
      </el-form-item>
      <el-form-item label="推荐人" prop="referral">
        <el-input v-model="searchData.referral" :maxlength="200" placeholder="请输入" allowClear></el-input>
      </el-form-item>
      <el-form-item label="推荐类型" prop="referralType">
				<el-select
					v-model="searchData.referralType"
					placeholder="请选择"
					clearable
					style="width: 100%"
				>
					<el-option
						v-for="item in referralTypeList"
						:key="item.referralTypeId"
            :label="item.referralTypeName"
            :value="item.referralTypeId"
						style="width: 100%"
					>
					</el-option>
				</el-select>
			</el-form-item>
		</el-form>

    <div class="btn-group">
      <div class="row-bg">
        <el-button type="primary" size="medium" @click="addPersonalFun">新建</el-button>
        <el-button type="primary" size="medium" @click="exportBtnFun" :loading="exportFlag">导出</el-button>
      </div>
      <div class="row-bg">
        <el-button type="primary" size="medium" @click="handleSearch()">查询</el-button>
        <el-button size="medium" @click="resetForm()">重置</el-button>
      </div>
    </div>

    <el-table
			ref="checktableData"
			:data="tableData"
			v-loading="tableLoading"
			:reserve-selection="true"
			center
			height="60vh"
      @selection-change="selectChangeFun"
		>
      <el-table-column type="selection" :selectable="selectableFun" width="55"></el-table-column>
			<el-table-column label="操作" prop="action" width="160">
				<template slot-scope="scope">
          <el-link type="primary" @click="editRowFun(scope.row)">编辑</el-link>
					<el-link style="margin-left: 12px;" type="primary" @click="deleteRowFun(scope.row)">删除</el-link>
				</template>
			</el-table-column>
      <el-table-column label="推荐码（手机号）" prop="phone" min-width="100"></el-table-column>
      <el-table-column label="推荐人" prop="referral" min-width="100"></el-table-column>
			<el-table-column label="推荐类型" prop="referralType" min-width="120">
        <template slot-scope="scope">
          <span>{{ lookforTypeStrFun(scope.row.referralType) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="createTime" min-width="120"></el-table-column>
		</el-table>
		<div class="pagination-container">
			<el-pagination
				background
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				layout="total, sizes,prev, pager, next,jumper"
				:current-page.sync="pagination.currPage"
				:page-size="pagination.pageSize"
				:page-sizes="[10, 20, 30, 50]"
				:total="total"
			>
			</el-pagination>
		</div>
    <AddPersonal ref="addPersonalRef" @opera-success="handleSearch"></AddPersonal>
  </div>
</template>
<script>
import AddPersonal from './components/AddPersonal.vue'
export default {
  components: {
    AddPersonal
  },
  data(){
    return {
      referralTypeList: [
				{
					referralTypeId: 1,
					referralTypeName: '门店导购',
				},
				{
					referralTypeId: 2,
					referralTypeName: '小区物业',
				},
				{
					referralTypeId: 3,
					referralTypeName: '普通用户',
				},
			],
      // 查询数据
      searchData: {
        phone: undefined,
        referral: undefined,
        referralType: undefined
      },
      // 表格数据
      tableData: [],
      tableLoading: false,
      pagination: {
        currPage: 1,
        pageSize: 10
      },
      total: 0,
      selectList: [],
      exportFlag: false
    }
  },
  created(){
    this.getList()
  },
  methods: {
    // 获取分页数据
    getList () {
      const url = `/autoapp-default-server-recovery/api/commission/referral/page`
      const params = {
        ...this.searchData,
        ...this.pagination
      }
			return this.HttpService.post(url, params).then(res => {
				if (res.statusCode === 200) {
          this.total = res.data.total || 0
          const resData = res.data.records || []
          this.tableData = resData
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
			})
    },
    // 查询
		handleSearch () {
			this.pagination.currPage = 1
			this.getList()
    },
    // 清空
		resetForm () {
			this.searchData = {
        phone: undefined,
        referral: undefined,
        referralType: undefined
      }
    },
    // 页码改变
    handleSizeChange (val) {
      this.pagination.currPage = 1
      this.pagination.pageSize = val
      this.getList()
    },
    handleCurrentChange () {
      this.getList()
    },
    // 选择改变
    selectChangeFun (selection) {
      this.selectList = selection
    },
    // 控制表格行是否可选
    selectableFun (row) {
      return row.waitCount > 0
    },
    // 新建
    addPersonalFun () {
      this.$refs.addPersonalRef.opendDialog('add')
    },
    // 编辑
    editRowFun (row) {
      // console.log('====row', row)
      this.$refs.addPersonalRef.opendDialog('edit', row)
    },
    // 删除
    deleteRowFun (row) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        // console.log('====row', row)
        const id = row.id
        if (id) {
          this.deleteReqFun(id)
        }else {
          this.$message.error('参数错误')
        }
      })
    },
    // 删除请求
    deleteReqFun (id) {
      const url = `/autoapp-default-server-recovery/api/commission/referral/delete?id=${id}`
      this.HttpService.get(url).then(res => {
        if (res.statusCode === 200) {
          this.$message.success('删除成功')
          this.handleSearch()
        } else {
          const msgTip = res.message || '请求失败'
          this.$message.error(msgTip)
        }
      }, err => {
        console.log('err', err)
      })
    },
    // 查找类型
    lookforTypeStrFun (type) {
      const typeObj = this.referralTypeList.find(item => item.referralTypeId == type)
      return typeObj ? typeObj.referralTypeName : type
    },
    // 导出
		exportBtnFun () {
			this.exportFlag = true
			setTimeout(() => {
				this.exportFlag = false
			}, 1200)
			const url = "/autoapp-default-server-recovery/api/commission/referral/export"
			const title = "推荐人员列表导出"
			const params = {
				...this.searchData,
				...this.pagination
			}
			this.global.exportExcel(url, params, title).catch((res) => {
				let blob = new Blob([res.response.data], {
					type: "application/json",
				})
				var blobReader = new Response(blob).json()
				blobReader.then((res) => {
					this.$message.error(res.message)
				})
			})
		}
  }
}
</script>
<style scoped lang='scss'>
.btn-group{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
	margin-bottom: 14px;
}
</style>


// WEBPACK FOOTER //
// src/views/commissionManage/recommendPersonnelManage/index.vue